export const cmsPaths = {
  '/cms-content/{id}': {
    get: {
      summary: 'Get CMS content by ID',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: { type: 'integer' },
          description: 'Content ID',
        },
      ],
      responses: {
        200: {
          description: 'CMS content',
          content: {
            'application/json': {
              schema: { $ref: '#/components/schemas/CMSContent' },
            },
          },
        },
      },
    },
    patch: {
      summary: 'Update CMS content',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: { type: 'integer' },
          description: 'Content ID',
        },
      ],
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              type: 'object',
              properties: {
                name: { type: 'string' },
                type: { type: 'string', enum: ['layout', 'page', 'email', 'component', 'navigation'] },
                position: { type: 'integer' },
                show_in_menu: { type: 'boolean' }
              }
            }
          }
        }
      },
      responses: {
        200: {
          description: 'Updated CMS content',
          content: {
            'application/json': {
              schema: { $ref: '#/components/schemas/CMSContent' },
            },
          },
        },
      },
    },
  },
  '/cms-content/{id}/translations': {
    get: {
      summary: 'Get content translations',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: { type: 'integer' },
          description: 'Content ID',
        }
      ],
      responses: {
        200: {
          description: 'Content translations',
          content: {
            'application/json': {
              schema: {
                type: 'array',
                items: { $ref: '#/components/schemas/CMSContentTranslation' }
              }
            }
          }
        }
      }
    }
  },
  '/cms-content/{id}/translations/{languageCode}': {
    put: {
      summary: 'Update content translation',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: { type: 'integer' },
          description: 'Content ID',
        },
        {
          name: 'languageCode',
          in: 'path',
          required: true,
          schema: { type: 'string' },
          description: 'Language code (e.g., en, es)',
        }
      ],
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              type: 'object',
              properties: {
                title: { type: 'string' },
                content: { type: 'string' },
                html_content: { type: 'string' },
                meta_description: { type: 'string' },
                meta_keywords: { type: 'string' },
                slug: { type: 'string' }
              }
            }
          }
        }
      },
      responses: {
        200: {
          description: 'Updated translation',
          content: {
            'application/json': {
              schema: { $ref: '#/components/schemas/CMSContentTranslation' }
            }
          }
        }
      }
    }
  },
  '/cms-content/tree': {
    get: {
      summary: 'Get content tree',
      responses: {
        200: {
          description: 'Content tree structure',
          content: {
            'application/json': {
              schema: {
                type: 'array',
                items: { $ref: '#/components/schemas/CMSContent' }
              }
            }
          }
        }
      }
    }
  },
  '/cms-content/by-slug': {
    get: {
      summary: 'Get content by slug',
      parameters: [
        {
          name: 'slug',
          in: 'query',
          required: true,
          schema: { type: 'string' },
          description: 'Content slug',
        },
        {
          name: 'languageCode',
          in: 'query',
          required: true,
          schema: { type: 'string' },
          description: 'Language code (e.g., en, es)',
        }
      ],
      responses: {
        200: {
          description: 'Content data',
          content: {
            'application/json': {
              schema: {
                oneOf: [
                  {
                    type: 'object',
                    properties: {
                      type: { type: 'string', enum: ['page'] },
                      translation: { $ref: '#/components/schemas/CMSContentTranslation' }
                    }
                  },
                  {
                    type: 'object',
                    properties: {
                      type: { type: 'string', enum: ['navigation'] },
                      children: {
                        type: 'array',
                        items: {
                          type: 'object',
                          properties: {
                            id: { type: 'integer' },
                            name: { type: 'string' },
                            type: { type: 'string' },
                            translation: { $ref: '#/components/schemas/CMSContentTranslation' },
                            children: { type: 'array' }
                          }
                        }
                      }
                    }
                  }
                ]
              }
            }
          }
        }
      }
    }
  }
};
